import { Dispatch } from 'redux';
import ActionType from '../actionTypes/graphicsLibraryActionType';
import ApiEndpoints from '../ApiEndpoints';
import { handleRequest } from './helpers';
import GraphicsLibraryTagsConverter from '../../converter/graphicsLibraryTagsConverter';
import GraphicsLibraryGraphicsConverter from '../../converter/GraphicsLibraryGraphicsConverter';
import { Sort } from '../../shared/hooks/useSorting';
import { CustomFilterItemValue } from '../../shared/components/filter/types';
import DesignsSimpleConverter from '../../converter/DesignsSimpleConverter';

export const loadGraphicTags =
    () =>
    async (dispatch: Dispatch): Promise<{ errors: any } | null> => {
        const url = ApiEndpoints.KAPINUA_GRAPHIC_TAGS_LOAD();
        const actionTypes = ActionType.loadTags;

        return handleRequest(
            url,
            dispatch,
            actionTypes,
            (GraphicsLibraryTagsRaw: any) => {
                return GraphicsLibraryTagsConverter.convertAll(
                    GraphicsLibraryTagsRaw
                );
            }
        );
    };

export const loadDesigns =
    (
        currentDesignId: string,
        customerId: number | null,
        guestId: number | null
    ) =>
    async (dispatch: Dispatch): Promise<{ errors: any } | null> => {
        const url = ApiEndpoints.KAPINUA_CUSTOMERS_DESIGNS_LOAD(
            currentDesignId,
            customerId,
            guestId
        );
        const actionTypes = ActionType.loadDesigns;

        return handleRequest(
            url,
            dispatch,
            actionTypes,
            (GraphicsLibraryDesignsRaw: any) => {
                return DesignsSimpleConverter.convertAll(
                    GraphicsLibraryDesignsRaw
                );
            }
        );
    };

export const loadGraphics =
    (
        filter: { [name: string]: number | string | boolean | null },
        page: number,
        pageSize: number,
        sort: Sort[] | null,
        customerId: number | null,
        guestId: number | null
    ) =>
    async (dispatch: Dispatch): Promise<{ errors: any } | null> => {
        const params: {
            orderBy?: string;
            orderDirection?: string;
            range?: string;
            currentDesignGraphics?: boolean | string;
        } = { ...filter };

        if (sort && sort.length) {
            params.orderBy = sort[0].id;
            params.orderDirection = sort[0].desc ? 'desc' : 'asc';
        }

        if (page !== null && pageSize !== null) {
            const from = page * pageSize;
            const to = (page + 1) * pageSize;
            params.range = `${from}-${to}`;
        }

        if (params.currentDesignGraphics) {
            params.currentDesignGraphics = window
                .getGraphicIdsFromCurrentDesign()
                .join('_');
        }

        const url = ApiEndpoints.KAPINUA_GRAPHICS_LOAD(customerId, guestId);
        const actionTypes = ActionType.loadGraphics;

        return handleRequest(
            url,
            dispatch,
            actionTypes,
            (graphicsRaw: any) => {
                return GraphicsLibraryGraphicsConverter.convertAll(graphicsRaw);
            },
            'get',
            params
        );
    };

export const loadGraphicsReset = () => ({
    type: ActionType.loadGraphics.reset,
});

export const deleteGraphic =
    (
        idGraphic: number,
        idDesignJson: string,
        customerId: number | null,
        guestId: number | null
    ) =>
    async (dispatch: Dispatch): Promise<{ errors: any } | null> => {
        const url = ApiEndpoints.GRAPHIC_LIBRARY_DELETE(
            idGraphic,
            idDesignJson,
            customerId,
            guestId
        );
        const actionTypes = ActionType.deleteGraphic;

        return handleRequest(url, dispatch, actionTypes);
    };

export const deleteGraphicReset = () => ({
    type: ActionType.deleteGraphic.reset,
});

export const setGraphicsFilter = (
    customFilter: CustomFilterItemValue[] | null
) => ({
    type: ActionType.graphicsFilter.set,
    customFilter,
});

export const clearGraphicsFilter = () => ({
    type: ActionType.graphicsFilter.clear,
});
